import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Layout
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import MobileStickyCTA from "@/components/layout/MobileStickyCTA";
import FloatingFreePassButton from "@/components/layout/FloatingFreePassButton";
import CookieNotice from "@/components/layout/CookieNotice";

// Pages
import HomePage from "@/pages/HomePage";
import LocationsPage from "@/pages/LocationsPage";
import LocationDetailPage from "@/pages/LocationDetailPage";
import MembershipsPage from "@/pages/MembershipsPage";
import ContactPage from "@/pages/ContactPage";
import CancellationPage from "@/pages/CancellationPage";
import FeedbackPage from "@/pages/FeedbackPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AboutPage from "@/pages/AboutPage";
import JerseyGirlsPage from "@/pages/JerseyGirlsPage";
import FAQPage from "@/pages/FAQPage";
import FreePassPage from "@/pages/FreePassPage";
import ThankYouGuestPassPage from "@/pages/ThankYouGuestPassPage";
import JoinThankYouPage from "@/pages/JoinThankYouPage";

function App() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/locations/:locationId" element={<LocationDetailPage />} />
            <Route path="/memberships" element={<MembershipsPage />} />
            <Route path="/free-pass" element={<FreePassPage />} />
            <Route path="/thank-you-3-day-guest-pass" element={<ThankYouGuestPassPage />} />
            <Route path="/join-thank-you" element={<JoinThankYouPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/customercare" element={<ContactPage />} />
            <Route path="/cancel" element={<CancellationPage />} />
            <Route path="/cancellation" element={<CancellationPage />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/wpautoterms/privacy-policy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/wpautoterms/terms-and-conditions" element={<TermsPage />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/jersey-girls" element={<JerseyGirlsPage />} />
            <Route path="/jersey-girls-women-only" element={<JerseyGirlsPage />} />
            <Route path="/support" element={<FAQPage />} />
            {/* Location detail pages with new URL structure */}
            <Route path="/giant-fitness-voorhees-nj" element={<LocationDetailPage />} />
            <Route path="/philadelphia" element={<LocationDetailPage />} />
            <Route path="/gloucester-township-nj" element={<LocationDetailPage />} />
            <Route path="/blenheim-new-jersey-women-only" element={<LocationDetailPage />} />
            <Route path="/moorestown-new-jersey" element={<LocationDetailPage />} />
            <Route path="/giant-fitness-woodbury-heights-nj" element={<LocationDetailPage />} />
            <Route path="/mt-ephraim" element={<LocationDetailPage />} />
            <Route path="/phillygirls" element={<LocationDetailPage />} />
            <Route path="/blackwood" element={<LocationDetailPage />} />
            <Route path="/jersey-girls-women-only-westville-nj" element={<LocationDetailPage />} />
            <Route path="/jersey-girls-women-only-voorhees-nj" element={<LocationDetailPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <CookieNotice />
        <MobileStickyCTA />
        <FloatingFreePassButton />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
